import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'intNumber',
  standalone: false
})
export class IntNumberPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}

  transform(value: string | number): string {
    let num: number;

    if (typeof value === 'string') {
      num = Number(value);
    } else if (typeof value === 'number') {
      num = value;
    } else {
      return '';
    }

    return this.decimalPipe.transform(Math.floor(num), '1.0-0');
  }
}
